const initialState = {
  selected: 'Standard Tuning E',
  animated_key: '',
  tuning: '',
  bounceIn: '',
  tunings: [
    {
      name: 'Standard Tuning E',
    },
    {
      name: 'Tune down 1/2 step',
    },
    {
      name: 'Tune down one step',
    },
    {
      name: 'Tune down two step',
    },
  ],
  standards: [
    {
      id: 1,
      name: 'G',
      sound: new Audio(require('../assets/sounds/standard/g.mp3')),
      isPlaying: false,
      string: 'string-4',
      string_animated: '',
      clicked: '',
    },
    {
      id: 2,
      name: 'B',
      sound: new Audio(require('../assets/sounds/standard/h.mp3')),
      isPlaying: false,
      string: 'string-5',
      string_animated: '',
      clicked: '',
    },
    {
      id: 3,
      name: 'EE',
      sound: new Audio(require('../assets/sounds/standard/ee.mp3')),

      isPlaying: false,
      string: 'string-6',
      string_animated: '',
      clicked: '',
    },
    {
      id: 4,
      name: 'D',
      sound: new Audio(require('../assets/sounds/standard/d.mp3')),
      isPlaying: false,
      string: 'string-3',
      string_animated: '',
      clicked: '',
    },
    {
      id: 5,
      name: 'A',
      sound: new Audio(require('../assets/sounds/standard/a.mp3')),
      isPlaying: false,
      string: 'string-2',
      string_animated: '',
      clicked: '',
    },
    {
      id: 6,
      name: 'E',
      sound: new Audio(require('../assets/sounds/standard/e.mp3')),
      isPlaying: false,
      string: 'string-1',
      string_animated: '',
      clicked: '',
    },
  ],
  down_halfs: [
    {
      id: 7,
      name: 'Gb',
      sound: new Audio(require('../assets/sounds/tunedownhalf/gb.mp3')),
      isPlaying: false,
      string: 'string-4',
      string_animated: '',
      clicked: '',
    },
    {
      id: 8,
      name: 'Bb',
      sound: new Audio(require('../assets/sounds/tunedownhalf/hb.mp3')),
      isPlaying: false,
      string: 'string-5',
      string_animated: '',
      clicked: '',
    },
    {
      id: 9,
      name: 'EEb',
      sound: new Audio(require('../assets/sounds/tunedownhalf/eeb.mp3')),

      isPlaying: false,
      string: 'string-6',
      string_animated: '',
      clicked: '',
    },
    {
      id: 10,
      name: 'Db',
      sound: new Audio(require('../assets/sounds/tunedownhalf/db.mp3')),
      isPlaying: false,
      string: 'string-3',
      string_animated: '',
      clicked: '',
    },
    {
      id: 11,
      name: 'Ab',
      sound: new Audio(require('../assets/sounds/tunedownhalf/ab.mp3')),
      isPlaying: false,
      string: 'string-2',
      string_animated: '',
      clicked: '',
    },
    {
      id: 12,
      name: 'Eb',
      sound: new Audio(require('../assets/sounds/tunedownhalf/eb.mp3')),
      isPlaying: false,
      string: 'string-1',
      string_animated: '',
      clicked: '',
    },
  ],
  down_ones: [
    {
      id: 13,
      name: 'F',
      sound: new Audio(require('../assets/sounds/tunedownone/f.mp3')),
      isPlaying: false,
      string: 'string-4',
      string_animated: '',
      clicked: '',
    },
    {
      id: 14,
      name: 'A',
      sound: new Audio(require('../assets/sounds/tunedownone/a.mp3')),
      isPlaying: false,
      string: 'string-5',
      string_animated: '',
      clicked: '',
    },
    {
      id: 15,
      name: 'DD',
      sound: new Audio(require('../assets/sounds/tunedownone/dd.mp3')),

      isPlaying: false,
      string: 'string-6',
      string_animated: '',
      clicked: '',
    },
    {
      id: 16,
      name: 'C',
      sound: new Audio(require('../assets/sounds/tunedownone/c.mp3')),
      isPlaying: false,
      string: 'string-3',
      string_animated: '',
      clicked: '',
    },
    {
      id: 17,
      name: 'G',
      sound: new Audio(require('../assets/sounds/tunedownone/g.mp3')),
      isPlaying: false,
      string: 'string-2',
      string_animated: '',
      clicked: '',
    },
    {
      id: 18,
      name: 'D',
      sound: new Audio(require('../assets/sounds/tunedownone/d.mp3')),
      isPlaying: false,
      string: 'string-1',
      string_animated: '',
      clicked: '',
    },
  ],
  down_twos: [
    {
      id: 19,
      name: 'Eb',
      sound: new Audio(require('../assets/sounds/tunedowntwo/eb.mp3')),
      isPlaying: false,
      string: 'string-4',
      string_animated: '',
      clicked: '',
    },
    {
      id: 20,
      name: 'G',
      sound: new Audio(require('../assets/sounds/tunedowntwo/g.mp3')),
      isPlaying: false,
      string: 'string-5',
      string_animated: '',
      clicked: '',
    },
    {
      id: 21,
      name: 'CC',
      sound: new Audio(require('../assets/sounds/tunedowntwo/cc.mp3')),

      isPlaying: false,
      string: 'string-6',
      string_animated: '',
      clicked: '',
    },
    {
      id: 22,
      name: 'Bb',
      sound: new Audio(require('../assets/sounds/tunedowntwo/bb.mp3')),
      isPlaying: false,
      string: 'string-3',
      string_animated: '',
      clicked: '',
    },
    {
      id: 23,
      name: 'F',
      sound: new Audio(require('../assets/sounds/tunedowntwo/f.mp3')),
      isPlaying: false,
      string: 'string-2',
      string_animated: '',
      clicked: '',
    },
    {
      id: 24,
      name: 'C',
      sound: new Audio(require('../assets/sounds/tunedowntwo/c.mp3')),
      isPlaying: false,
      string: 'string-1',
      string_animated: '',
      clicked: '',
    },
  ],
};

export default initialState;
